import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fd2ffc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gas-price" }
const _hoisted_2 = { class: "gas-price-header is-flex is-justify-content-space-between" }
const _hoisted_3 = { class: "speed-label" }

import { ref, onMounted, computed } from 'vue'
import { fromWei } from 'web3-utils'
import BigNumber from 'bignumber.js'

import Slider from '@/popup/components/shared/Slider.vue'
import useNumbers from '@/popup/compositions/useNumbers'
import { logInfo } from '@/shared/logger'
import { SliderRange } from '@/popup/components/shared/Slider'

type Props = {
  /**
   * Currently selected value for transaction.
   */
  maxPriorityFeePerGas?: string
  /**
   * Current max priority fee per gas recommended by the network.
   * Used as an orientier for the values on the slider.
   */
  networkMaxPriorityFeePerGas?: string
}

type Emits = {
  (event: 'update-max-priority-fee-per-gas', value: string): void
  (event: 'change-max-priority-fee-per-gas', value: string): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MaxPriorityFeePerGasSlider',
  props: {
    maxPriorityFeePerGas: {},
    networkMaxPriorityFeePerGas: {}
  },
  emits: ["update-max-priority-fee-per-gas", "change-max-priority-fee-per-gas"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const { formatNumber } = useNumbers()

const gasMax = ref<number>(0)
const low = ref<number>(0)
const high = ref<number>(0)
const tooltipLowValues = ref(0)
const tooltipHighValues = ref(0)
const range = ref<SliderRange>()
const maxPriorityFeePerGasRef = ref(Number(props.maxPriorityFeePerGas || 0))

onMounted(() => {
  const priorityFee = new BigNumber(props.networkMaxPriorityFeePerGas ?? '0')
  gasMax.value = priorityFee.multipliedBy(new BigNumber(1.5)).toNumber()
  low.value = Number(priorityFee.multipliedBy(new BigNumber(0.85)))
  high.value = Number(priorityFee.multipliedBy(new BigNumber(1.15)))
  tooltipLowValues.value = Number(priorityFee.multipliedBy(new BigNumber(0.35)))
  tooltipHighValues.value = Number(priorityFee.multipliedBy(new BigNumber(1.4)))

  // Making sure `maxPriorityFeePerGasRef` is withing bounds of low-high values
  maxPriorityFeePerGasRef.value = Math.max(
    Math.min(maxPriorityFeePerGasRef.value, gasMax.value),
    0
  )

  logInfo(
    'Transaction speed slider:',
    `Min gas: 0 (wei)`,
    `Est gas: ${props.networkMaxPriorityFeePerGas} (wei)`,
    `Max gas: ${gasMax.value} (wei)`
  )

  // priority fee is optional so 0 should be acceptable
  range.value = {
    min: 0,
    '50%': priorityFee.toNumber(),
    max: gasMax.value,
  }
})

const transactionSpeed = computed(() => {
  const maxPriorityFeePerGas = Number(props.maxPriorityFeePerGas ?? '0')

  if (maxPriorityFeePerGas < low.value) {
    return 'low'
  }

  if (maxPriorityFeePerGas > high.value) {
    return 'high'
  }

  return 'medium'
})

const onUpdateMaxPriorityFeePerGas = (value: number) => {
  emits('update-max-priority-fee-per-gas', Math.trunc(value).toString())
}

const onChangeMaxPriorityFeePerGas = (value: number) => {
  emits('change-max-priority-fee-per-gas', Math.trunc(value).toString())
}

const onSlideMaxPriorityFeePerGas = (value: number) => {
  if (value === 0) {
    return `0 Gwei`
  }
  const formattedNumber = formatNumber(
    fromWei(Math.trunc(value).toString(), 'Gwei')
  )
  const leadingZeroesAfterDecimalPoint =
    formattedNumber.match('^\\d+(\\.(0+)?)?')?.[2]?.length ?? 0
  let fractionDigits = 4
  if (leadingZeroesAfterDecimalPoint) {
    fractionDigits = Math.min(
      18,
      fractionDigits + leadingZeroesAfterDecimalPoint
    )
  }
  return `${Number(formattedNumber).toFixed(fractionDigits)} Gwei`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('confirmation.header.tx_speed.header')), 1 /* TEXT */),
      _createElementVNode("span", {
        class: _normalizeClass(`tag is-small ${transactionSpeed.value} speed-tag`)
      }, _toDisplayString(_ctx.$t(`confirmation.header.tx_speed.${transactionSpeed.value}`)), 3 /* TEXT, CLASS */)
    ]),
    (range.value)
      ? (_openBlock(), _createBlock(Slider, {
          key: 0,
          value: maxPriorityFeePerGasRef.value,
          low: tooltipLowValues.value,
          high: tooltipHighValues.value,
          range: range.value,
          "has-tooltips": true,
          format: onSlideMaxPriorityFeePerGas,
          "tooltip-position": "top",
          onOnUpdate: onUpdateMaxPriorityFeePerGas,
          onOnChange: onChangeMaxPriorityFeePerGas,
          class: "mx-2"
        }, null, 8 /* PROPS */, ["value", "low", "high", "range"]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})